import { AxiosResponse } from 'axios';

import { UDNICK } from '../../../../../../../service/udnick';

export const getVeiculosPortal = {
  getVeiculosPortal: (parceiros: number | undefined): Promise<AxiosResponse> =>
    UDNICK.callService('getVeiculosPortal', { parceiros }),
};
